module.exports = "/assets/site/images/1.png?8e35601c10dbd50e72809c6747058d75";